import { SidePopupLayout } from "src/component/SidePopupLayout"
//import {browserName, mobileModel} from 'react-device-detect'
import { useContext } from "react"
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, Icon, ScreenTitle } from "src/style"
//import SuccessGif from 'src/assets/gif/success.gif'
import UserContext from "src/provider/state-manager/userProvider"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import {ReactComponent as DownloadIcon} from 'src/assets/img/download-receipt-icon.svg'
//import ProfileCompletionIcon from 'src/assets/img/success-icon-safari.svg'
import helpers from "src/utils/helpers"
import { moneyFormat } from "src/utils/utility"
import { AppCenterPopupD2, CenterPopupHeaderD2, Reciept } from "src/component"
import Lottie from "lottie-react";
import successGif from "src/assets/gif/success.json";
import successConfetti from "src/assets/gif/successConfetti.json"
//import CompletedIcon from 'src/assets/svg/tx-completed-icon'

export const TransferCompletedD2: React.FC<any> = ({data, close}) => {
    const {user:{accountInfo}} = useContext(UserContext)
    const {info: {institutionData}} = useContext(AppInfoContext)

    const acctDetails = helpers.getAccountDetailsWithAcctNo(accountInfo, data?.senderAccount)
    
    const additionalData = {
        senderAccountName: acctDetails?.accountName,
        recipientBankName: data?.transferType === '0' ? institutionData?.name : data?.beneficiaryBank,
        recipientAccountName: data?.beneficiaryName,
        recipientAccountNumber: data?.beneficiaryAccount,
        narration: data?.remarks,
        transactionDate: helpers.getDateTime()
    }
    
    return (
        <AppCenterPopupD2 height='86' zIndex='6' overflow='hidden' close={close}>
            <CenterPopupHeaderD2 title='' close={close} />
            <AbsoluteContainer top="0" left='0'>
                <Lottie animationData={successConfetti} loop={true} />
            </AbsoluteContainer>
            <CustomContainer 
                height="86"
                style={{maxHeight: '92.5%'}}
                className="popup-content-container"
            >
                <GridContainer 
                    topMargin="1.5" 
                >
                    <CustomContainer width="20">
                        <Lottie animationData={successGif} loop={true} />
                    </CustomContainer>
                    <ScreenTitle textSize="2.2" fontWeight="700" topMargin="2.5">{data?.isScheduleTransfer ? "Schedule Saved Successfully" :"Transfer Successful"}</ScreenTitle>
                    <CustomContainer
                        minHeight="12.4" padding="2" 
                        topMargin="2" bgColor="#ffffff"
                        borderColor="#EAECF0" radius="0.8"
                    >
                        <FlexRow justifyContent="space-between" gap="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Sender</AppSpan>
                            <AppText fontWeight="600" color="#212121">{acctDetails?.accountName}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Sender Acct</AppSpan>
                            <AppText fontWeight="600" color="#212121">{data?.senderAccount}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Receiver</AppSpan>
                            <AppText fontWeight="600" color="#212121">{data?.beneficiaryName}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Receiver Acct</AppSpan>
                            <AppText fontWeight="600" color="#212121">{data?.beneficiaryAccount}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Date & Time</AppSpan>
                            <AppText fontWeight="600" color="#212121">{helpers.getDateTime()}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Amount</AppSpan>
                            <AppText fontWeight="600" color="#212121">{moneyFormat(String((Number(data?.amount))), true,institutionData?.defaultCurrency)}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Beneficiary Bank</AppSpan>
                            <AppText fontWeight="600" color="#212121">{data?.transferType === '0' ? institutionData?.name : data?.beneficiaryBank}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <AppSpan color='#212121'>Transfer Type</AppSpan>
                            <AppText fontWeight="600" color="#212121">{data?.transferType != '2' ? 'Intra bank' : 'Inter bank'}</AppText>
                        </FlexRow>
                        { data?.transactionReference &&
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <AppSpan color='#212121'>Transaction Reference</AppSpan>
                                <AppText fontWeight="600" color="#212121">{data?.transactionReference}</AppText>
                            </FlexRow>
                        }
                    </CustomContainer>
                    { (data && !data?.isScheduleTransfer) &&
                        <CustomContainer topMargin="2" className="download-receipt">
                            <Reciept txData={{...data, ...additionalData, amount: String((Number(data?.amount)))}}/>
                        </CustomContainer>
                    }
                    <Button 
                        width='100' sizeUnit="%" height='4.4' topMargin="2.5"
                        borderColor='#0D968F' hoverBgColor='#ffffff' 
                        hoverColor='#0D968F' titleSize='1.4'
                        onClick={close}
                    >
                        Done
                    </Button>
                </GridContainer>
            </CustomContainer>
        </AppCenterPopupD2>
    )
}